(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-announcement-bar"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const lines = document.querySelectorAll('.announcement-desktop .announcement-line');
  let current = 0;
  const displayDuration = 2500;
  const transitionDelay = 500;

  function showNextLine() {
    if (lines.length <= 1) return;
    lines[current].classList.remove('active');
    setTimeout(() => {
      current = (current + 1) % lines.length;
      lines[current].classList.add('active');
    }, transitionDelay);
  }

  setInterval(showNextLine, displayDuration + transitionDelay);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
